











import { Component, Mixins, Prop, Emit, Watch } from "vue-property-decorator";
import { Vector } from "../../../../../../../base/domain/drawing";
import { DragKinds } from "../../../../../../../base/components/dragging";
import { TransformerFactory, ITransformable } from "../../../../../../../base/components/dragging/mixins";
import {
  FormatPageStructureEditor,
  IFormatObjectEditable,
} from "../../../../../../domain/editableFormat";
import {
  IVectorCoordinateEditable, instanceOfIVectorCoordinateEditable,
} from "../../../../../../domain/editableFormat/properties";
import { FormatPageMouseTrackableMixin } from "../mixins";

@Component
export default class VectorCoordinatableObjectTransformer extends Mixins(FormatPageMouseTrackableMixin) {
  @Prop()
  source: IFormatObjectEditable;

  @Prop()
  event: PointerEvent;

  @Prop()
  kind: DragKinds;

  @Emit()
  finished() {}

  data() {
    return {
      sourceVector: null as Vector,
      transformedVector: null as Vector,
    };
  }
  sourceVector: Vector;
  transformedVector: Vector;

  created(): void {
    if (!instanceOfIVectorCoordinateEditable(this.source)) {
      this.$logger.warn("線形描画対象外のオブジェクトからの要求です.実装を再確認してください.");
      return;
    }
    this.sourceVector = Vector.from(this.source.vector().getValue());
    this.transformedVector = this.sourceVector.clone();
  }

  handleMouseEntered(event: PointerEvent): void {
    this.onMouseEntered(this.pageElement, event);
    this.update(event);
  }

  handleMouseMoved(event: PointerEvent): void {
    this.onMouseMoved(this.pageElement, event);
    this.update(event);
  }

  handleMouseReleased(event: PointerEvent): void {
    this.onMouseReleased(this.pageElement, event);
    this.finish(true);
  }

  private update(event: PointerEvent): void {
    this.transformedVector = this.getTransformedVector(event);
    this.writePropertyWhenValid(s => s.setOffsets({
      source: this.source,
      relocatingOffset: {
        x: 0,
        y: 0,
      },
      transformingRatesFromCenter: {
        x: 1,
        y: 1,
        width: 1,
        height: 1,
      },
      transformingVector: this.transformedVector,
    }));
  }

  private getTransformedVector(event: PointerEvent): Vector {
    return this.createTransformer(event)
      .transformVector(this.sourceVector, this.toClientLocation(this.pageElement, event), this.kind);
  }

  private createTransformer(event: PointerEvent): ITransformable {
    const factory = new TransformerFactory({
      shift: "aspectRatioFixed",
      control: "centerFixed",
      alt: "grid",
    });
    return factory.create(event);
  }

  private finish(shouldApply: boolean = false): void {
    this.writePropertyWhenValid(s => {
      const editor = s as FormatPageStructureEditor;
      editor.setOffsets();
      if (shouldApply) {
        if (instanceOfIVectorCoordinateEditable(this.source)) {
          this.transformObject(editor, this.source);
        }
      }
    });
    this.finished();
  }

  private transformObject(editor: FormatPageStructureEditor, object: IFormatObjectEditable & IVectorCoordinateEditable): void {
    const clone = object.clone() as IFormatObjectEditable & IVectorCoordinateEditable;
    clone.vector().setValue(this.transformedVector);
    editor.updateObject(clone);
  }

  @Watch("isMouseTracking")
  onMouseTrackingChanged(newValue: boolean, oldValue: boolean): void {
    if (!newValue) {
      this.finish(false);
    }
  }
}
